/**
 * Rótulo, papel e ação por status de fatura — porta `faturas_cte_m_model.dart`
 * (App Tresco), a fonte canônica. A cor é o papel do `Selo` do painel (0094).
 *
 * O backend (`fret_fatura`) usa as formas **femininas**: PENDENTE, VENCIDA,
 * PAGA, CANCELADA. As masculinas e `AGUARDANDO` são aceitas por
 * compatibilidade — o app faz o mesmo —, mas nenhuma delas é emitida hoje.
 */

import type { Papel } from '../../../common/interface';

export function rotuloStatus(status: string): string {
  switch (status.toUpperCase()) {
    case 'PAGO': case 'PAGA': return 'Pago';
    case 'VENCIDO': case 'VENCIDA': return 'Vencido';
    case 'CANCELADO': case 'CANCELADA': return 'Cancelado';
    case 'AGUARDANDO': case 'PENDENTE': return 'Aguardando pagamento';
    // Status novo do servidor aparece cru, em vez de sumir da tela.
    default: return status;
  }
}

export function papelStatus(status: string): Papel {
  switch (status.toUpperCase()) {
    case 'PAGO': case 'PAGA': return 'sucesso';
    case 'VENCIDO': case 'VENCIDA': return 'perigo';
    case 'CANCELADO': case 'CANCELADA': return 'neutro';
    default: return 'atencao';
  }
}

/**
 * Uma fatura está em aberto quando NÃO está paga nem cancelada.
 *
 * É **denylist, não allowlist**, e de propósito: status desconhecido continua
 * mostrando o botão de pagar. Errar para o lado de oferecer o pagamento de algo
 * já quitado é reversível; esconder o pagamento de uma dívida real bloqueia a
 * emissão do cooperado sem ele entender por quê.
 */
export function faturaEmAberto(status: string): boolean {
  switch (status.toUpperCase()) {
    case 'PAGO': case 'PAGA': case 'CANCELADO': case 'CANCELADA': return false;
    default: return true;
  }
}
